import React, { Component } from 'react'
import CourseDefaultImg from '../../Images/crystal_springs_course.jpeg';
import Brochure from '../../pdf/2025_Golf_Brochure.pdf';
import './eventsCard.css';

export default class EventPageCrad extends Component {
    render() {
        return (

          <React.Fragment>
        <div className='e-object2'>
        <div className="band3">
                    <div class="item-3">
                        <a class="card3">
                            <div id='gotoevents' class="thumb3" style={{backgroundImage: `url(${CourseDefaultImg}` }}></div>
                            <article>
                            <h2>7th Annual Golf Outing</h2>
                                <p>
                                </p>
                                    <div className="sec-1"> 
                                        <ul>
                                            <li><b>Address:</b> 1 Wild Turkey Way, Hamburg, NJ 07419</li>
                                            <li><b>Venue:</b> Crystal Springs Golf Club</li>
                                            <li><b>Date:</b> September 14th, 2026</li>
                                            <li><b> Breakfast & Registration:</b> 8:00 AM</li>
                                            <li><b> Shotgun Start:</b> 9:00 AM</li>
                                        </ul>
                                    </div>

                                    <div className ='sectionOps'>
                                      {/* <h3>Ticket Options:</h3> */}
                                      <div className='ops'>
                                        <div className='ops2'>
                                              {/* <h3>Golfing</h3> */}
                                              <li><h3>Includes:</h3>
                                                <li>- 18 holes on one of New Jersey's premier courses</li>
                                                <li>- Continental breakfast and post-round buffet lunch</li>
                                                <li>- Contests, raffles, and the chance to support a great cause</li>
                                              </li>
                                              
                                              {/* <div><a class="brochure" href={Brochure} download><b><i>View Brochure</i></b></a></div> */}
                                              {/* <a href='/golf-outing'>
                                                <button className="btn signUp-btn">
                                                  Sign Up
                                                </button>
                                              </a> */}
                                              <br/>
                                              <div><i>Registration for golf is closed. Thank you for the support. Please contact us to be put on a waitlist.</i></div>
                                              {/* <br/> */}
                                              {/* <div><i>Registration will open shortly. Thank you.</i></div> */}
                                        </div>

                                        {/* <div className='ops2'>
                                              <h3>Dinner</h3>
                                              <li><b>Includes:</b> 
                                                  <li>Buffet Dinner and Open Bar</li>                                              
                                              </li>
                                            <div><a class="brochure" href={Brochure} download><b><i>View Brochure</i></b></a></div>
                                            <a href='/golf-outing'>
                                              <button className="btn signUp-btn">
                                                Sign Up
                                              </button>
                                            </a>
                                        </div> */}
                                      </div>

                                  {/* <div className='closed-reg-sec'>
                                    <div>Registration for the 4th annual Alan J. Anderson Foundation Memorial Golf Outing is now closed.</div>
                                    <div>Thank you to our very generous sponsors, donors, and supporters for all your support. We look forward to seeing you next year!</div>
                                    <div>For additional information or to donate a raffle item, please email alanjandersonfoundation@gmail.com.</div> */}

                                    {/* <button className="btn signUp-btn"><a href='/donations'>Donate</a></button> */}
                                  {/* </div> */}

                                    </div>
                            </article>
                        </a>
                    </div>
        </div>
        </div>
          </React.Fragment>
        )
    }
}
